import { render, staticRenderFns } from "./UpdateSurveyTemplate.vue?vue&type=template&id=1440d40e"
import script from "./UpdateSurveyTemplate.vue?vue&type=script&lang=js"
export * from "./UpdateSurveyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports